module.exports = __webpack_public_path__ + "static/img/recommendation.4c43ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recommendation.png
// module id = 4G/K
// module chunks = 1